/**
 * Created by sung on 2017-03-10.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,ButtonModule,PaginatorModule, DropdownModule} from "primeng/primeng";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from "@angular/http";
import {RouterModule} from "@angular/router";
import { MamAdminService } from '../../service/mam_service.component';
import { MamVisitorService } from '../../service/mam_visitor_service.component';
import { Device } from '../../model/device';
import { VisitorLog } from '../../model/visitorLog';
import { Visitor } from '../../model/visitor';
import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import {ExDialogModule} from "../../component/dialog.component";
import {SearchModule} from "../../component/search.component";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {SelectItem} from "primeng/components/common/api";
import { CookieService } from 'angular2-cookie/core';
import { User } from '../../model/user';
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS
import {Paginator} from "primeng/components/paginator/paginator";
import * as glob from "../../service/global_url";

@Component({
selector: 'visitor-statistics',
templateUrl: 'visitor_log_statistics.html'
})
export class VisitorLogStatisticsComponent implements OnInit {

  // model
  private visitorLogList : VisitorLog[] = [];
  private conditionList : any[] = [];
  detailSelected : VisitorLog;

  // dialog
  detailShow : boolean = false;
  policyShow : boolean = false;
  dialogWidth : number = 700;
  title : string;
  // policyDialogWidth : number = 900;
  // policyShow : boolean = false;

  // filter
  searchIsTrue : boolean;
  searchKeyword: string;
  searchValue : string;
  searchValueIsDropBox : boolean;
  searchTextfiledIsUse : boolean;
  searchId: number;

  dateIsTrue : boolean = true;
  startDate: string;
  endDate: string;
  excelIsTrue : boolean = true;

  //filter item
  searchIDs: SelectItem[];
  visitorTypeList : SelectItem[];
  deviceStatus : SelectItem[];
  osTypeList : SelectItem[];
  searchValueDropBox : SelectItem[];

  // paging
  listTotalCount: number;
  rowNum: number;
  pageNum: number;
  @ViewChild('paginator') paginator: Paginator;
  
  // global constant flag
  private visitorInfoModifyIsTrue : boolean = glob.visitorInfoModifyIsTrue;

  
  
  translate : TranslateServiceForm;
  
  ngOnInit() {
    
  }

  constructor(private service : MamVisitorService, private adminService : MamAdminService, private cookie : CookieService, private logger : Logger, private _translate : TranslateServiceForm) {
    this.translate = _translate;

    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_VISITOR_PhoneNumber'), value: 'mobileNumber'});
    // this.searchIDs.push({label: this.translate.instant('LANG_VISITOR_Type'), value: 'visitorType'});
    this.searchIDs.push({label: this.translate.instant('LANG_DEVICE_device'), value: 'osType'});
    this.searchIDs.push({label: this.translate.instant('LANG_DeviceStatus'), value: 'deviceStatus'});
    
    this.visitorTypeList = [];
    this.visitorTypeList.push({label: '---------------', value: ''});
    this.visitorTypeList.push({label: this.translate.instant('LANG_VISITOR_Type_Common'), value: '0'});
    this.visitorTypeList.push({label: this.translate.instant('LANG_VISITOR_Type_Regular'), value: '1'});

    this.deviceStatus = [];
    this.deviceStatus.push({label: '---------------', value: ''});
    this.deviceStatus.push({label: this.translate.instant('LANG_PolicyIn'), value: 'DEVICE_POLICY_IN'});
    this.deviceStatus.push({label: this.translate.instant('LANG_PolicyOut'), value: 'DEVICE_POLICY_OUT'});
    this.deviceStatus.push({label: this.translate.instant('LANG_App_Install')+"("+this.translate.instant('AL_ProfileCreateToNormal')+")", value: 'DEVICE_REGISTOR'});
    this.deviceStatus.push({label: this.translate.instant('LANG_App_Delete')+"("+this.translate.instant('AL_ProfileDeleteToNormal')+")", value: 'DEVICE_UNREGISTOR'});


    this.osTypeList = [];
    this.osTypeList.push({label: '---------------', value: ''});
    this.osTypeList.push({label: this.translate.instant('LANG_Android'), value: 'ANDROID'});
    this.osTypeList.push({label: this.translate.instant('LANG_iPhone'), value: 'IOS'});
    this.osTypeList.push({label: this.translate.instant('LANG_WindowPhone'), value: 'WINDOWS_OS'});
    this.osTypeList.push({label: this.translate.instant('Lang_DeviceSumOther'), value: 'OTHER'});

    this.rowNum = 10;
    this.pageNum = 0;
    this.getVisitorLogList();
  }

  //event///////////////////////////////////////
  paginate(event) {
    this.logger.debug(event);
    this.rowNum = event.rows;
    this.pageNum = event.page;
    this.getVisitorLogList();
  }

  searchKeywordChange(event) {
    this.logger.debug("data => ", event);
    if(event == 'osType') {
      this.searchValueIsDropBox = true;
      this.searchValueDropBox = this.osTypeList;
      this.searchTextfiledIsUse = false;
    } else if(event == 'visitorType') {
      this.searchValueDropBox = this.visitorTypeList;
      this.searchTextfiledIsUse = false;
      this.searchValueIsDropBox = true;
    } else if(event == 'deviceStatus') {
      this.searchValueIsDropBox = true;
      this.searchValueDropBox = this.deviceStatus;
      this.searchTextfiledIsUse = false;
    } else if(event == 'all' || !event) {
      this.searchTextfiledIsUse = false;
      this.searchValueIsDropBox = false;
    } else {
      this.searchTextfiledIsUse = true;
      this.searchValueIsDropBox = false;
    }
  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchKeyword = event.searchId;
    this.searchValue = event.searchText;
    this.startDate = event.sDate;
    this.endDate = event.eDate;
    this.searchId = event.searchId;

    if(this.endDate < this.startDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }
    //this.paginator.changePageToFirst({});
    this.pageNum = 0;
    this.getVisitorLogList();

  }

  showDetail(data) {
    this.detailShow = true;
    this.dialogWidth = 600;
    this.detailSelected = data;
    this.logger.debug(data);
    this.title = this.translate.instant('LANG_Detail');
  }

  showPolicy(data) {
    this.policyShow = true;
    this.dialogWidth = 600;
    this.detailSelected = data;
    this.logger.debug(data);
    this.title = this.translate.instant('LANG_Policy_Status');
    this.getPolicyConditionList(data.policy.id, 1, 100, data);  }

  hideDialog(event){
    this.detailShow = false;
    this.policyShow =false;
  }

  exportExcel(data) {
    this.logger.debug("excel 다운 : ",data);
    if (data) {
      this.searchIsTrue = data.searchIsTrue;
      this.searchKeyword = data.searchId;
      this.searchValue = data.searchText;
      this.startDate = data.sDate;
      this.endDate = data.eDate;
      this.searchId = data.searchId;  
    }
    this.getVisitorLogListExcel();

  }
  /////////////////////////////////////////////
  

  getVisitorLogList() {
    var urlPath = "/visitor-log";
    this.service.getList(urlPath, this.pageNum, this.rowNum, this.searchKeyword, this.searchValue, this.startDate, this.endDate)
    .subscribe(
      value => {
        if (value != null) {
          this.visitorLogList = value.data.content;
          this.listTotalCount = value.data.totalElements;
          this.logger.debug(this.listTotalCount);
        } else {
          this.visitorLogList = [];
          this.listTotalCount = 0;
        }
      },
      error => {
        let result = error.json();
        this.logger.error("-- error : " + error);
        alert(result.message);
      },
      () => {}
    );
  }
  getVisitorLogListExcel() {
    this.logger.debug("download >>");
    this.service.getVisitorLogListExcel(this.searchKeyword, this.searchValue, this.startDate, this.endDate);
  }

  getPolicyConditionList(policyId:number, page:number, max:number, data:any) {
    this.adminService.getPolicyConditionList(policyId,page, max).subscribe(
      value => {
        this.conditionList = value.rows;
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.detailSelected = data;
        this.policyShow = true;
      }
    )
  }
}


@NgModule({
  imports: [SearchDropBoxModule, DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,ButtonModule,PaginatorModule, ExDialogModule, SearchModule, DropdownModule, MainPipeMoudle, TranslatePipeMoudle],
  exports: [VisitorLogStatisticsComponent],
  declarations: [VisitorLogStatisticsComponent],
  providers: [MamAdminService, MamVisitorService, CookieService],
})
export class VisitorLogStatisticsModule {
}



// WEBPACK FOOTER //
// ./src/app/page/visitor/visitor_log_statistics.ts